import { useContext, useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useLocation, useNavigate } from 'react-router-dom';

import { DataContext } from 'providers/data';
import { ParamsDataListStores, ParamsPageWebView } from 'utils/typeServices';

import { Box, Typography, Collapse } from '@mui/material';

import Modals from 'components/views/Modals';
import Input from 'components/views/form/Input';
import DatePicker from 'components/views/DatePicker';
import NavSubPage from 'components/views/NavSubPage';
import ParseWebView from 'components/views/ParseWebView';
import CardStore from 'components/views/Scheduling/CardStore';
import { ButtonRectangle } from 'components/views/form/Button';
import PhoneCopyWebView from 'components/views/PhoneCopyWebView';

import LocalPhoneOutlinedIcon from '@mui/icons-material/LocalPhoneOutlined';
import headerCondicaoEspecial from 'assets/images/header_condicao_especial.png';
import whatsAppClick from 'assets/images/WhatsApp_Click.png';

import { NumberSection, ContentOptions, Ul, ContentNewSearch, ContentCards, LinkExtermal, PromotionalContent, PromotionalFooter } from './styles';

const Rescheduling = ({ isWebView }: ParamsPageWebView) => {
    const navigate = useNavigate();
    const { state } = useLocation();
    const [isLoading, setIsLoading] = useState(false);
    const [showError, setShowError] = useState(false);
    const [isError, setIsError] = useState(false);
    const [isSuccess, setIsSuccess] = useState(false);
    const [showErrorExceeded, setShowErrorExceeded] = useState(false);

    const [dateSelected, setDateSelected] = useState('');

    const [storeSelected, setStoreSelected] = useState<number>(0);
    const [arrayDatesList, setArrayDatesList] = useState<Array<{
        date: string
    }>>();
    const [arrayListStores, setArrayListStores] = useState<Array<ParamsDataListStores>>();
    const { register, setValue, watch, formState: { errors } } = useForm();

    const { dataEffectSchedule, selectedCar, dataOrderDetailScheduling, dataListStoresByZipCode, dataGenerateReschedulingFee, dataPerfilUser, dataGetPlatformRemoval, handlePostGetListStoresByZipCode, handleGetOrderDetailScheduling, handleClearScheduling, handleGetPerfilUser, handleClearSchedulingHome } = useContext(DataContext);

    const [showPromotionalModal, setShowPromotionalModal] = useState(false);
    const [promotionalDismissed, setPromotionalDismissed] = useState(false);
    const [promotionalData, setPromotionalData] = useState<{ name: string; value: number } | null>(null);

    const cep = watch('cep');

    const handlePostGetListStoresByZipCodeState = (cep: string) => {
        if (state?.isScheduling) {
            setIsLoading(true);
            handlePostGetListStoresByZipCode({
                token: localStorage.getItem('token')!,
                body: {
                    CD_PEDIDO: state?.orderId,
                    DT_INICIO: new Date().toISOString(),
                    FL_DOMICILIAR: false,
                    NR_CEP_AGENDAMENTO: cep?.replace('-', ''),
                    NR_TIPO_AGENDAMENTO: state?.isMaintenance ? 9 : 2
                }
            });
        } else if (dataOrderDetailScheduling && cep) {
            setIsLoading(true);
            handlePostGetListStoresByZipCode({
                token: localStorage.getItem('token')!,
                body: {
                    CD_PEDIDO: dataOrderDetailScheduling.CD_PEDIDO,
                    DT_INICIO: dataOrderDetailScheduling.DT_INICIO,
                    DT_VALIDADE_COTACAO: dataOrderDetailScheduling.DT_VALIDADE_COTACAO,
                    FL_DOMICILIAR: false,
                    NR_CEP_AGENDAMENTO: cep?.replace('-', ''),
                    NR_TIPO_AGENDAMENTO: dataOrderDetailScheduling.NR_TIPO_AGENDAMENTO
                }
            });
        }
    }

    useEffect(() => {
        setIsLoading(false);

        if (dataListStoresByZipCode) {
            let listDates: Array<{ date: string }> = [];
            let listStores: Array<ParamsDataListStores> = [];
            dataListStoresByZipCode.map(({ DATAS_HORAS, LOJA }) => DATAS_HORAS.map(({ Data, Horarios }) =>
            (
                // eslint-disable-next-line no-sequences
                listDates.push({ date: Data }),
                listStores.push({
                    CD_LOJA: LOJA.CD_LOJA,
                    CD_UF: LOJA.CD_UF,
                    DS_PONTO_REFERENCIA: LOJA.DS_PONTO_REFERENCIA,
                    NM_BAIRRO: LOJA.NM_BAIRRO,
                    NM_CIDADE: LOJA.NM_CIDADE,
                    NM_ENDERECO: LOJA.NM_ENDERECO,
                    NOME_LOJA: LOJA.NOME_LOJA,
                    NR_CEP: LOJA.NR_CEP,
                    NR_DISTANCIA: LOJA.NR_DISTANCIA,
                    NR_NUMERO: LOJA.NR_NUMERO,
                    Date: Data,
                    Horarios: Horarios
                })
            )));

            setArrayDatesList(listDates);
            setArrayListStores(listStores);
        } else if (dataListStoresByZipCode === false) {
            setShowErrorExceeded(true);
        }
    }, [dataListStoresByZipCode]);

    useEffect(() => {
        if (state?.isScheduling && state?.nr_plataforma && typeof dataPerfilUser === "undefined") {
            setIsLoading(true);
            handleGetPerfilUser({ token: localStorage.getItem('token')!, nrPlatform: state?.nr_plataforma });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [state]);

    useEffect(() => {
        if (state?.isScheduling && dataPerfilUser && typeof dataListStoresByZipCode === "undefined") {
            setIsLoading(true);
            setValue('cep', dataPerfilUser?.CEP_PERNOITE);
            handlePostGetListStoresByZipCodeState(dataPerfilUser?.CEP_PERNOITE);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [state, dataPerfilUser]);

    useEffect(() => {
        if (state && !dataOrderDetailScheduling && !state?.isScheduling) {
            setIsLoading(true);
            handleGetOrderDetailScheduling({ token: localStorage.getItem('token')!, cdPedido: state?.orderId });
        }

        if (state && dataOrderDetailScheduling && typeof dataListStoresByZipCode === "undefined") {
            setIsLoading(true);
            setValue('cep', dataOrderDetailScheduling.NR_CEP_AGENDAMENTO);
            handlePostGetListStoresByZipCodeState(dataOrderDetailScheduling.NR_CEP_AGENDAMENTO);
            return;
        }
        if (dataOrderDetailScheduling === false) {
            setShowError(true);
        }
        if (dataOrderDetailScheduling === null) {
            setShowErrorExceeded(true);
        }
        setIsLoading(false);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedCar, state, dataOrderDetailScheduling, dataListStoresByZipCode]);

    useEffect(() => {
        if (dataEffectSchedule) {
            setIsSuccess(true);
        } else if (dataEffectSchedule === false) {
            setIsError(true);
        }
    }, [dataEffectSchedule]);

    useEffect(() => {
        const isDesinstalacao = state?.isScheduling
            ? !state?.isMaintenance
            : (dataOrderDetailScheduling && typeof dataOrderDetailScheduling === 'object')
                ? dataOrderDetailScheduling.NR_TIPO_AGENDAMENTO === 2
                : false;

        if (isDesinstalacao && !promotionalDismissed && dataGetPlatformRemoval && state?.nr_plataforma) {
            const platform = dataGetPlatformRemoval.find(
                (p) => p.NR_PLATAFORMA === state.nr_plataforma
            );
            if (platform?.FL_NAO_DEVOLUCAO_PROMOCIONAL && platform?.VL_TAXA) {
                const firstName = (dataPerfilUser && typeof dataPerfilUser === 'object')
                    ? dataPerfilUser.NOME_COMPLETO?.split(' ')[0] || ''
                    : '';
                setPromotionalData({ name: firstName, value: platform.VL_TAXA });
                setShowPromotionalModal(true);
            }
        }
    }, [state, dataOrderDetailScheduling, dataGetPlatformRemoval, dataPerfilUser, promotionalDismissed]);

    return (
        <ParseWebView typePage='page' isWebView={isWebView}>
            <Box sx={{
                width: '100%',
                display: 'flex',
                flexDirection: 'column'
            }}>
                <NavSubPage title={state?.isScheduling ? 'Agendamento' : 'Reagendamento'} link={isWebView ? '/wb/agendamentos' : '/agendamentos'} />
                <Typography fontSize='1rem' color='primary.main' lineHeight='19px'>
                    Para o seu {state?.isScheduling ? 'agendamento' : 'reagendamento'} estamos apresentando o novo calendário <br />
                    usando os <strong>dados ja fornecidos:</strong>
                </Typography>

                <Box sx={{ margin: '1rem 0 2rem' }}>
                    <Box sx={{ display: 'flex' }}>
                        <NumberSection>
                            1
                        </NumberSection>
                        <Typography fontSize='1.25rem' padding=".5rem 0 0 .685rem">
                            Local do atendimento:
                        </Typography>
                    </Box>
                    <Box>
                        <ContentOptions>
                            <li>
                                <input style={{ cursor: 'pointer' }} type="radio" checked={true} />
                                <label htmlFor='domestic'>Lojas Parceiras</label>
                            </li>
                        </ContentOptions>

                        <Collapse in={true}>
                            <Box paddingLeft='2.5625rem' marginTop='1.5rem' sx={{ 'button': { width: '100%', maxWidth: '16.56rem' } }}>
                                <ContentNewSearch>
                                    <Input
                                        name='cep'
                                        label='CEP de referência'
                                        placeholder='99999-999'
                                        type='tel'
                                        mask
                                        error={errors.cep}
                                        register={{ ...register("cep", { pattern: cep }) }}
                                        disabled={isLoading}
                                    />

                                    <a href="https://buscacepinter.correios.com.br/app/endereco/index.php" target='blank'>
                                        Não sei qual é meu CEP
                                    </a>
                                </ContentNewSearch>
                                <ButtonRectangle loadingBtn={isLoading} name='PESQUISAR' onClick={() => handlePostGetListStoresByZipCodeState(cep)} />
                            </Box>
                        </Collapse>
                    </Box>
                </Box>

                <Collapse in={!isLoading && (arrayDatesList ? true : false)}>
                    <Box>
                        <Box sx={{ display: 'flex' }}>
                            <NumberSection>
                                2
                            </NumberSection>
                            <Typography fontSize='1.25rem' padding=".5rem 0 0 .685rem">
                                Selecione a nova <strong>data e horário:</strong>
                            </Typography>
                        </Box>

                        <Collapse in={arrayDatesList ? true : false}>
                            <Box sx={{ display: 'flex', marginTop: '1.25rem', gap: '6.25rem' }}>
                                <Box sx={{ maxWidth: 'fit-content' }}>
                                    {arrayDatesList && <DatePicker arrayListDates={arrayDatesList} handleDateSelected={(e) => setDateSelected(e)} />}
                                    <Box display='flex' justifyContent='space-between' padding='1.18rem 0 1.625rem'>
                                        <Box display='flex' alignItems='center'>
                                            <div style={{ width: '1.81rem', height: '1.81rem', background: '#D9D9D9', border: '2px solid #D9D9D9', borderRadius: 100 }} />
                                            <Typography fontSize='.81rem' paddingLeft='.5rem'>
                                                Datas disponíveis
                                            </Typography>
                                        </Box>

                                        <Box display='flex' alignItems='center'>
                                            <div style={{ width: '1.81rem', height: '1.81rem', background: '#97C93D', border: '2px solid #97C93D', borderRadius: 100 }} />
                                            <Typography fontSize='.81rem' paddingLeft='.5rem'>
                                                Data escolhida
                                            </Typography>
                                        </Box>
                                    </Box>
                                </Box>
                            </Box>
                        </Collapse>

                        <Collapse in={arrayListStores ? true : false}>
                            <Box sx={{ width: '100%', maxWidth: { xs: '100%', md: '34rem' } }}>
                                <Typography fontSize='1.25rem' fontWeight={700} paddingBottom='.5rem' textAlign='left'>
                                    LOJAS PARCEIRAS
                                </Typography>
                                <ContentCards>
                                    {arrayListStores?.map(({ NOME_LOJA, DS_PONTO_REFERENCIA, CD_LOJA, NR_DISTANCIA, NM_ENDERECO, NR_NUMERO, NR_CEP, NM_BAIRRO, NM_CIDADE, Date, Horarios }, index) =>
                                        dateSelected === Date &&
                                        <CardStore
                                            key={index}
                                            date={Date}
                                            hours={Horarios}
                                            NR_CEP={NR_CEP}
                                            CD_LOJA={CD_LOJA}
                                            NOME_LOJA={NOME_LOJA}
                                            NR_NUMERO={NR_NUMERO}
                                            NM_BAIRRO={NM_BAIRRO}
                                            NM_CIDADE={NM_CIDADE}
                                            NM_ENDERECO={NM_ENDERECO}
                                            NR_DISTANCIA={NR_DISTANCIA}
                                            DS_PONTO_REFERENCIA={DS_PONTO_REFERENCIA}
                                            isSelected={storeSelected}
                                            isStoreSelected={(e) => setStoreSelected(e)}
                                            isIndexStore={index}
                                            isSchedulingUninstall={state?.isScheduling || false}
                                            isMaintenance={state?.isMaintenance || false}
                                            CD_PEDIDO={state?.orderId || 0}
                                            NR_PLATAFORMA={state?.nr_plataforma || 0}
                                            isWebView={isWebView}
                                        />
                                    )}
                                </ContentCards>
                            </Box>
                        </Collapse>
                    </Box>
                </Collapse>
                {(!state?.isMaintenance && (dataOrderDetailScheduling && [9, 13].indexOf(dataOrderDetailScheduling.NR_TIPO_AGENDAMENTO) < 0)) &&
                    <Box sx={{ marginTop: '1.875rem' }}>
                        <Typography sx={{
                            marginBottom: '.5rem',
                            fontSize: '.9375rem',
                            color: 'primary.light',
                            fontWeight: 700
                        }}>
                            * Regras de reagendamento:
                        </Typography>
                        <Ul>
                            <li>
                                <p>
                                    O prazo de reagendamento é de 24 horas a data/hora agendada. Após este período, uma<br />
                                    taxa de <strong>R$ {dataOrderDetailScheduling.VL_TOTAL.toFixed(2).replace('.', ',')}</strong> será cobrada para realizar o reagendamento. O boleto <strong>deverá</strong> ser<br />
                                    quitado em até 3 horas antes da realização do serviço.
                                </p>
                            </li>
                        </Ul>
                    </Box>
                }
            </Box>

            <Modals open={showError}>
                <Box sx={{ borderRadius: '8px', width: { xs: 'calc(100vw - 2rem)', md: '26rem' } }}>
                    <Box sx={{ borderRadius: '8px 8px 0 0', padding: '1.8675rem 1rem .875rem' }}>
                        <Typography sx={{ fontSize: '1.5625rem', fontWeight: 700, textAlign: 'center' }}>
                            ATENÇÃO!
                        </Typography>
                        <Typography sx={{ fontSize: '.875rem', fontWeight: 600, paddingTop: '1rem', textAlign: 'center', lineHeight: '17px' }}>
                            A quantidade de reagendamentos foi <strong>excedida.</strong><br />
                            Entre em contato com a nossa<br />
                            Central de Atendimento:
                        </Typography>
                    </Box>
                    <Box sx={{ backgroundColor: 'primary.main', borderRadius: '0 0 8px 8px', padding: { xs: '1rem 2.5rem 1.625rem', md: '1rem 3.8125rem 1.625rem' }, 'button': { width: '100%' } }}>
                        <Typography fontSize='.875rem' color='white' paddingBottom='.9375rem' lineHeight='1.3' textAlign='center'>
                            Atendimento de Segunda à Sexta das 08h as 18h e aos Sábados das 8h às 14h
                        </Typography>
                        <Box>
                            <Typography fontSize='.875rem' color='white' paddingBottom='.2rem'>
                                São Paulo
                            </Typography>
                            <LinkExtermal href="tel:1136169000">
                                (011) 3616-9000
                                <LocalPhoneOutlinedIcon />
                            </LinkExtermal>
                        </Box>
                        <Box>
                            <Typography fontSize='.875rem' color='white' paddingBottom='.2rem'>
                                Outras localidades
                            </Typography>
                            <LinkExtermal href="tel:08007742000">
                                0800 774 2000
                                <LocalPhoneOutlinedIcon />
                            </LinkExtermal>
                        </Box>
                        <ButtonRectangle name='Fechar' onClick={() => { handleClearScheduling(); handleClearSchedulingHome(); navigate(isWebView ? '/wb/agendamentos' : '/agendamentos'); }} />
                    </Box>
                </Box>
            </Modals>

            <Modals open={showErrorExceeded}>
                <Box sx={{ borderRadius: '8px', width: { xs: 'calc(100vw - 2rem)', md: '26rem' } }}>
                    <Box sx={{ borderRadius: '8px 8px 0 0', padding: '1.8675rem 1rem .875rem' }}>
                        <Typography sx={{ fontSize: '1.5625rem', fontWeight: 700, textAlign: 'center' }}>
                            ATENÇÃO!
                        </Typography>
                        {dataListStoresByZipCode === false ?
                            <Typography sx={{ fontSize: '.875rem', fontWeight: 600, paddingTop: '1rem', textAlign: 'center', lineHeight: '17px' }}>
                                A data limite para efetuar o <br />
                                agendamento foi excedida, favor entrar <br />
                                em contato com a nossa central de <br />
                                atendimento.
                            </Typography>
                            :
                            <Typography sx={{ fontSize: '.875rem', fontWeight: 600, paddingTop: '1rem', textAlign: 'center', lineHeight: '17px' }}>
                                Tivemos um problema ao iniciar o agendamento.<br />
                                Entre em contato com a nossa<br />
                                Central de Atendimento:
                            </Typography>
                        }
                    </Box>
                    <Box sx={{ backgroundColor: 'primary.main', borderRadius: '0 0 8px 8px', padding: { xs: '1rem 2.5rem 1.625rem', md: '1rem 3.8125rem 1.625rem' }, 'button': { width: '100%' } }}>
                        <Typography fontSize='.875rem' color='white' paddingBottom='.9375rem' lineHeight='1.3' textAlign='center'>
                            Atendimento de Segunda à Sexta das 08h as 18h e aos Sábados das 8h às 14h
                        </Typography>
                        <Box>
                            <Typography fontSize='.875rem' color='white' paddingBottom='.2rem'>
                                São Paulo
                            </Typography>
                            {isWebView ?
                                <PhoneCopyWebView text='(011) 3616-9000' link='(011) 3616-9000' />
                                :
                                <LinkExtermal href="tel:1136169000">
                                    (011) 3616-9000
                                    <LocalPhoneOutlinedIcon />
                                </LinkExtermal>
                            }
                        </Box>
                        <Box>
                            <Typography fontSize='.875rem' color='white' paddingBottom='.2rem'>
                                Outras localidades
                            </Typography>
                            {isWebView ?
                                <PhoneCopyWebView text='0800 774 2000' link='0800 774 2000' />
                                :
                                <LinkExtermal href="tel:08007742000">
                                    0800 774 2000
                                    <LocalPhoneOutlinedIcon />
                                </LinkExtermal>
                            }
                        </Box>
                        <ButtonRectangle name='Fechar' onClick={() => { handleClearScheduling(); handleClearSchedulingHome(); navigate(isWebView ? '/wb/agendamentos' : '/agendamentos'); }} />
                    </Box>
                </Box>
            </Modals>

            <Modals open={isError || isSuccess}>
                {isSuccess &&
                    <Box sx={{ borderRadius: '8px', width: { xs: 'calc(100vw - 2rem)', md: 'auto' } }}>
                        <Box sx={{
                            padding: { xs: '1.625rem .6rem 1rem', md: '1.625rem 1.31rem' },
                            borderRadius: '0px 0px 8px 8px',
                            textAlign: 'center'
                        }}>
                            <Typography fontSize='1.25rem' fontWeight={700}>
                                {state?.isScheduling ? 'AGENDAMENTO' : 'REAGENDAMENTO'} REALIZADO!
                            </Typography>
                            <Typography sx={{ fontSize: '.875rem', paddingTop: '1rem', lineHeight: '17px' }}>
                                <strong>Importante:</strong> Os detalhes do agendamento foram <br />
                                enviados para o seu e-mail de cadastro.
                            </Typography>
                            {dataOrderDetailScheduling && dataGenerateReschedulingFee && dataOrderDetailScheduling.TAXA_REAGENDAMENTO &&
                                <Typography sx={{ fontSize: '.875rem', paddingTop: '1rem', lineHeight: '17px', 'a': { color: 'primary.main', textDecoration: 'underline' } }}>
                                    Caso queira ver o boleto agora,&nbsp;
                                    <a download='boleto' href={`data:application/pdf;base64,${dataGenerateReschedulingFee?.PDF}`}>
                                        <strong>
                                            clique aqui!
                                        </strong>
                                    </a>
                                </Typography>
                            }
                        </Box>
                        <Box sx={{ backgroundColor: 'primary.main', borderRadius: '0 0 8px 8px', padding: '1.435rem 3.8125rem 1.625rem', 'button': { width: '100%' } }}>
                            <ButtonRectangle name='CONTINUAR' onClick={() => { handleClearScheduling(); handleClearSchedulingHome(); navigate(isWebView ? '/wb/agendamentos' : '/agendamentos'); }} />
                        </Box>
                    </Box>
                }
                {isError &&
                    <Box sx={{ borderRadius: '8px', width: { xs: 'calc(100vw - 2rem)', md: '26rem' } }}>
                        <Box sx={{ borderRadius: '8px 8px 0 0', padding: '1.8675rem 1rem .875rem' }}>
                            <Typography sx={{ fontSize: '1.5625rem', fontWeight: 700, textAlign: 'center' }}>
                                ATENÇÃO!
                            </Typography>
                            <Typography sx={{ fontSize: '.875rem', fontWeight: 600, paddingTop: '1rem', textAlign: 'center', lineHeight: '17px' }}>
                                A quantidade de reagendamentos foi <strong>excedida.</strong><br />
                                Entre em contato com a nossa<br />
                                Central de Atendimento:
                            </Typography>
                        </Box>
                        <Box sx={{ backgroundColor: 'primary.main', borderRadius: '0 0 8px 8px', padding: { xs: '1rem 2.5rem 1.625rem', md: '1rem 3.8125rem 1.625rem' }, 'button': { width: '100%' } }}>
                            <Typography fontSize='.875rem' color='white' paddingBottom='.9375rem' lineHeight='1.3' textAlign='center'>
                                Atendimento de Segunda à Sexta das 08h as 18h e aos Sábados das 8h às 14h
                            </Typography>
                            <Box>
                                <Typography fontSize='.875rem' color='white' paddingBottom='.2rem'>
                                    São Paulo
                                </Typography>
                                <LinkExtermal href="tel:1136169000">
                                    (011) 3616-9000
                                    <LocalPhoneOutlinedIcon />
                                </LinkExtermal>
                            </Box>
                            <Box>
                                <Typography fontSize='.875rem' color='white' paddingBottom='.2rem'>
                                    Outras localidades
                                </Typography>
                                <LinkExtermal href="tel:08007742000">
                                    0800 774 2000
                                    <LocalPhoneOutlinedIcon />
                                </LinkExtermal>
                            </Box>
                            <ButtonRectangle name='Fechar' onClick={() => { handleClearScheduling(); handleClearSchedulingHome(); navigate(isWebView ? '/wb/agendamentos' : '/agendamentos'); }} />
                        </Box>
                    </Box>
                }
            </Modals>

            <Modals open={showPromotionalModal}>
                <Box sx={{ borderRadius: '8px', width: { xs: 'calc(100vw - 2rem)', md: '24rem' }, overflow: 'hidden', bgcolor: 'background.paper' }}>
                    <Box sx={{ width: '100%' }}>
                        <img src={headerCondicaoEspecial} alt="Condição Especial" style={{ width: '100%', display: 'block' }} />
                    </Box>

                    <PromotionalContent>
                        <Typography className="greeting">
                            Olá <strong>{promotionalData?.name}</strong>,
                        </Typography>
                        <Typography className="description">
                            Temos uma condição especial para você:<br />
                            <strong>mantenha o equipamento</strong> no veículo, sem<br />
                            necessidade de retirada!
                        </Typography>
                        <Typography className="price-label">
                            &#10549; Por apenas
                        </Typography>
                        <Box className="price-container">
                            <Typography className="price-currency">R$</Typography>
                            <Typography className="price-value">
                                {promotionalData?.value?.toFixed(2).replace('.', ',')}
                            </Typography>
                        </Box>
                        <Typography className="price-info">
                            Sem custos de retirada, deslocamento<br />
                            ou qualquer burocracia.
                        </Typography>
                    </PromotionalContent>

                    <PromotionalFooter>
                        {isWebView ? (
                            <Typography className="footer-cta">
                                Fale conosco no WhatsApp pelo <strong>11 36169000</strong>,<br />
                                aproveite essa oportunidade imperdível.
                            </Typography>
                        ) : (
                            <>
                                <Typography className="footer-cta">
                                    <strong>Clique abaixo</strong> e fale com a gente,<br />
                                    aproveite essa oportunidade imperdível:
                                </Typography>
                                <button
                                    className="whatsapp-btn"
                                    onClick={() => window.open('https://api.whatsapp.com/send/?phone=551136169000', '_blank')}
                                >
                                    <img src={whatsAppClick} alt="WhatsApp" style={{ width: '3.5rem', height: '3.5rem' }} />
                                </button>
                            </>
                        )}
                        <Typography className="option-text">Opção: Devolva o rastreador</Typography>
                        <button className="remind-later" onClick={() => { setShowPromotionalModal(false); setPromotionalDismissed(true); }}>
                            LEMBRAR DEPOIS
                        </button>
                    </PromotionalFooter>
                </Box>
            </Modals>
        </ParseWebView>
    );
}

export default Rescheduling;